import type { LocationRecord } from '@libs/data-access/entities'
import type { ShiftMealsList } from '@libs/data-access/queries'

import type { MealValue } from '../components/MealRow/MealRow'

type Props = {
  meals: {
    value: MealValue
  }[]
  weeklyscheduleLocation: LocationRecord
  shiftMeals: ShiftMealsList
}
/**
 * Retreive all the meals from the form and compute if we need to add those or delete them from the DB
 * @deprecated you are not that bad of a person, please don't use it!
 */
const getMealsToSendLegacy = ({
  meals,
  weeklyscheduleLocation,
  shiftMeals
}: Props) => {
  const mealsToAdd = meals?.map(({ value: mealData }) => ({
    id: typeof mealData.id === 'number' ? mealData.id : null,
    planned_meal_type:
      mealData.meal?.value || weeklyscheduleLocation?.default_meal_type,
    real_meal_type:
      mealData.meal?.value || weeklyscheduleLocation?.default_meal_type
  }))

  const mealsToDelete = shiftMeals?.map(mealItem => {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    const mealId = mealItem.get('id')

    const keepMeal = mealsToAdd?.find(newMeal => {
      return newMeal.id && newMeal.id === mealId
    })

    if (!keepMeal) {
      return { id: mealId, _destroy: 1 }
    }

    return null
  })

  return mealsToAdd
    ? [...mealsToAdd, ...mealsToDelete.toArray().filter(Boolean)]
    : mealsToDelete.toArray().filter(Boolean)
}

export default getMealsToSendLegacy
